export default __webpack_public_path__ + "static/media/homepage-1.b30bd28c.webp";